import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LOCALE_LABELS, SUPPORTED_LOCALES } from '../i18n';
export default function LanguageSwitcher() {
    const { i18n, t } = useTranslation();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    // Cierra al hacer click fuera o al pulsar Escape.
    useEffect(() => {
        const onDocClick = (e) => {
            if (!ref.current?.contains(e.target))
                setOpen(false);
        };
        const onEsc = (e) => e.key === 'Escape' && setOpen(false);
        document.addEventListener('mousedown', onDocClick);
        document.addEventListener('keydown', onEsc);
        return () => {
            document.removeEventListener('mousedown', onDocClick);
            document.removeEventListener('keydown', onEsc);
        };
    }, []);
    const current = (i18n.resolvedLanguage ?? i18n.language ?? 'en');
    const label = LOCALE_LABELS[current] ?? current;
    const choose = (loc) => {
        void i18n.changeLanguage(loc);
        document.documentElement.lang = loc;
        setOpen(false);
    };
    return (_jsxs("div", { className: "lang-switcher", ref: ref, children: [_jsxs("button", { type: "button", className: "lang-button", "aria-haspopup": "listbox", "aria-expanded": open, "aria-label": t('common.language'), onClick: () => setOpen((v) => !v), children: [_jsx("span", { className: "lang-globe", "aria-hidden": true, children: "\uD83C\uDF10" }), _jsx("span", { className: "lang-current", children: label }), _jsx("span", { className: `lang-chevron ${open ? 'open' : ''}`, "aria-hidden": true, children: "\u25BE" })] }), open && (_jsx("ul", { className: "lang-menu", role: "listbox", children: SUPPORTED_LOCALES.map((loc) => (_jsx("li", { children: _jsxs("button", { type: "button", role: "option", "aria-selected": loc === current, className: `lang-option ${loc === current ? 'active' : ''}`, onClick: () => choose(loc), children: [_jsx("span", { className: "lang-code", children: loc.toUpperCase() }), _jsx("span", { className: "lang-name", children: LOCALE_LABELS[loc] })] }) }, loc))) }))] }));
}
